import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ActionModalTemplate } from '@core';
import { PlayerLeaveReason } from '@core-http';
import { SingleRadioItemModel } from '@ui-components';

@Component({
  selector: 'lib-leave-game-reason',
  templateUrl: './leave-game-reason.component.html',
  styleUrls: ['./leave-game-reason.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, NgClass]
})
export class LeaveGameReasonComponent implements ActionModalTemplate<PlayerLeaveReason> {
  @Input() reasons: SingleRadioItemModel<PlayerLeaveReason>[] = [];
  @Input() withAlert: boolean = false;

  readonly selected: WritableSignal<PlayerLeaveReason | null> = signal<PlayerLeaveReason | null>(null);

  isSelected(value: PlayerLeaveReason): boolean {
    return this.selected() === value;
  }

  setData(event: CustomEvent): void {
    this.selected.set(event.detail.value);
  }
}
